import { Type } from "@sinclair/typebox";
import { TypeBoxToType } from "@whatslly/types/TypeBoxToType";

/** `detached` is a lake whose destination is gone: the data stays in the customer's bucket,
 * and a destination later created over the same bucket adopts it instead of backfilling again. */
export const LAKE_STATUSES = ["backfilling", "ready", "detached"] as const;
export type LakeStatus = (typeof LAKE_STATUSES)[number];
export const LakeStatusSchema = Type.Unsafe<LakeStatus>({ type: "string", enum: [...LAKE_STATUSES] });

export const LakeBackfillCountersSchema = Type.Object({
  totalFiles: Type.Number(),
  processedFiles: Type.Number(),
  /** Day files the last pass could not read; retried every pass, and the lake stays `backfilling` until they succeed. */
  failedFiles: Type.Number(),
  syncedMessages: Type.Number(),
  copiedMedia: Type.Number(),
});
export type LakeBackfillCounters = TypeBoxToType<typeof LakeBackfillCountersSchema>;
